import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-pencil.tsx
/**
* icon.16.pencil
*
* Keywords: edit, pen, write, modify, create, drawing, compose, diagonal
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTMuNjcgMi4wMS4xOTMuMDM0IDIgLjVjLjIuMDUuMzg1LjE0LjU0NS4yNjNsLjE1My4xMzIgNyA3YTEuNSAxLjUgMCAwIDEgMCAyLjEyMWwtMS41IDEuNWExLjUgMS41IDAgMCAxLTIuMTIyIDBsLTctN2ExLjUgMS41IDAgMCAxLS4zNTYtLjU3MmwtLjAyLS4wNjQtLjAxNy0uMDYtLjUwMS0yaC0uMDAxQTEuNSAxLjUgMCAwIDEgMy42NyAyLjAxbTUuODMgOS42OTcgMS4xNDYgMS4xNDZhLjUuNSAwIDAgMCAuNzA3IDBsMS41LTEuNWEuNS41IDAgMCAwIDAtLjcwN0wxMS43MDggOS41ek0zLjYyMSAzLjAxNWEuNS41IDAgMCAwLS42MDYuNjA2bC41IDIgLjAyMS4wNjVxLjAzOC4wOTUuMTEuMTY4TDguNzkzIDExIDExIDguNzkzIDUuODU0IDMuNjQ2YS41LjUgMCAwIDAtLjIzMy0uMTMxeiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=21789-13295
*/
const Icon16Pencil = memo(function Icon16Pencil(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "m3.67 2.01.193.034 2 .5c.2.05.385.14.545.263l.153.132 7 7a1.5 1.5 0 0 1 0 2.121l-1.5 1.5a1.5 1.5 0 0 1-2.122 0l-7-7a1.5 1.5 0 0 1-.356-.572l-.02-.064-.017-.06-.501-2h-.001A1.5 1.5 0 0 1 3.67 2.01m5.83 9.697 1.146 1.146a.5.5 0 0 0 .707 0l1.5-1.5a.5.5 0 0 0 0-.707L11.708 9.5zM3.621 3.015a.5.5 0 0 0-.606.606l.5 2 .021.065q.038.095.11.168L8.793 11 11 8.793 5.854 3.646a.5.5 0 0 0-.233-.131z"
		})
	});
});
//#endregion
export { Icon16Pencil };

//# sourceMappingURL=icon-16-pencil.js.map